function pad(value) {
  return String(value).padStart(2, '0');
}

export function toIsoDate(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

function endOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

function addDays(date, amount) {
  const next = new Date(date);
  next.setDate(next.getDate() + amount);
  return next;
}

export const SCORE_CARD_PERIOD_OPTIONS = [
  { value: 'this-month', label: 'This Month' },
  { value: 'last-month', label: 'Last Month' },
  { value: 'last-30-days', label: 'Last 30 Days' },
  { value: 'last-90-days', label: 'Last 90 Days' },
  { value: 'year-to-date', label: 'Year to Date' },
  { value: 'custom', label: 'Custom Range' },
];

export function resolveScoreCardPeriod(value, now = new Date(), custom = {}) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let start = startOfMonth(today);
  let end = today;

  if (value === 'last-month') {
    const previousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    start = startOfMonth(previousMonth);
    end = endOfMonth(previousMonth);
  } else if (value === 'last-30-days') {
    start = addDays(today, -29);
  } else if (value === 'last-90-days') {
    start = addDays(today, -89);
  } else if (value === 'year-to-date') {
    start = new Date(today.getFullYear(), 0, 1);
  } else if (value === 'custom') {
    return {
      startDate: custom.startDate || toIsoDate(start),
      endDate: custom.endDate || toIsoDate(end),
    };
  }

  return { startDate: toIsoDate(start), endDate: toIsoDate(end) };
}

export function formatReportingPeriod(startDate, endDate) {
  if (!startDate || !endDate) return '';
  const start = new Date(`${startDate}T00:00:00`);
  const end = new Date(`${endDate}T00:00:00`);
  const sameMonth = start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth();
  const fullMonth = start.getDate() === 1 && end.getDate() === endOfMonth(end).getDate();
  if (sameMonth && fullMonth) {
    return start.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
  }
  const format = { month: 'short', day: 'numeric', year: 'numeric' };
  return `${start.toLocaleDateString(undefined, format)} – ${end.toLocaleDateString(undefined, format)}`;
}
